<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item
        v-for="(item, index) in newbreadList"
        :key="index"
        :to="item.path != '' ? item.path : ''"
        replace
        v-show="routerName.indexOf(item.name) == -1"
        >{{ item.name }}</el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "Bread", //面包屑
  props: {
    //传值
    breadList: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      routerName: ["Home", "detail", "About"],
    };
  },
  components: {
    //引入模块
  },
  watch: {
    // watch擅长处理的场景：一个数据影响多个数据
  },
  computed: {
    // computed擅长处理的场景：一个数据受多个数据影响
    newbreadList() {
      console.log(this.$route.matched, this.$route);
      const { query } = this.$route;
      var arr;
      if (JSON.stringify(this.breadList) == "{}" || !this.breadList) {
        const regex = new RegExp(`${"{"}(.*?)${"}"}`);
        arr = this.$route.matched
          .map((item) => {
            // 进行匹配并获取结果
            const matchResult = item.meta.title.match(regex);

            var json = {
              name: !matchResult ? item.meta.title : query[matchResult[1]],
              path: item.redirect ? "" : item.path,
            };
            if (!item.components.default.name) {
              json.path = item.path;
            }

            return json;
          })
          .filter((item, index, self) => {
            return index === self.findIndex((obj) => obj.name === item.name);
          });
      } else {
        arr = this.breadList;
      }
      console.log(arr);
      return arr;
    },
  },
  mounted: function () {
    // 编译好的HTML挂载到页面完成后执行的事件钩子
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
    console.log("Home");
  },
  activated: function () {
    // 狗子触发顺序最后时执行，当再次进入（前进或者后退）时，只触发activated
  },
  methods: {
    // 组件的方法
  },
  beforeCreate: function () {
    // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  },
  created: function () {
    // 实例已经创建完成之后被调用。在这一步，实例已完成以下的配置：数据观测(data observer)，属性和方法的运算， watch/event 事件回调。然而，挂载阶段还没开始，el 属性目前不可见。
  },
  beforeMount: function () {
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  beforeUpdate: function () {
    // 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  },
  updated: function () {
    // 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    // 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。然而在大多数情况下，你应该避免在此期间更改状态，因为这可能会导致更新无限循环。
    // 该钩子在服务器端渲染期间不被调用。
  },
  beforeDestroy: function () {
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
  },
  destroyed: function () {
    // Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器会被移除，所有的子实例也会被销毁。 该钩子在服务器端渲染期间不被调用。
  },
};
</script>
<style scoped>
.el-breadcrumb {
  margin-bottom: 20px;
  border-left: 3px solid green;
  padding-left: 10px;
  /* font-weight: bold; */
}
.el-breadcrumb >>> .el-breadcrumb__inner {
  color: #5d933b;
  font-weight: bold;
  font-size: 16px; /* no */
}
.el-breadcrumb >>> .el-breadcrumb__inner:hover {
  color: #5d933b;
  font-weight: bold;
  font-size: 16px; /* no */
}
</style>